/**
 * Transform API after sales conditions to the date until when the offer part can be refunded
 *
 * @param afterSalesConditions The API AfterSaleCondition objects
 * @returns The refund deadline, or undefined if there is no refund condition
 */
export function transformRefundDeadline(afterSalesConditions?: ApiSchema['AfterSaleCondition'][]): Date | undefined {
    const refundConditionDate = afterSalesConditions?.find(c => c.condition === 'REFUND')?.validUntil;
    return refundConditionDate ? zurichDate(refundConditionDate) : undefined;
}
